import React from 'react';
import style from './style';
import DossiersDataTable from '../../../../components/dossiers/DossiersDataTable';

const Archives = ({contextThirdparty, archivedDossiers, refetch}) => {
  const { classes } = style();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        {archivedDossiers && (
          <DossiersDataTable
            dossiers={archivedDossiers}
            monitored={false}
            component="thirdparty"
            pageSize={10}
            multiDataGridPage
            sheetVariant={true}
            onDeactivation={refetch}
            onVisibleRowsCountChange={(count) => {}}
            onReactivateDossierNavigation={refetch}
            fromTp
            contextThirdparty={contextThirdparty}
          />
        )}
      </div>
    </div>
  );
};

export default Archives;
